(function () {
  window.aurelleTrack = function (eventName, payload) {
    var data = payload || {};
    data.path = data.path || window.location.pathname;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, data));

    window.dispatchEvent(
      new CustomEvent('aurelle:' + eventName, { detail: data })
    );
  };

  function sourceFor(element) {
    return element.getAttribute('data-aurelle-source') ||
      (element.closest('#first-access') ? 'first-access' : '') ||
      (element.closest('[data-product-grid]') ? 'collection' : '') ||
      (element.closest('.site-footer') ? 'footer' : '') ||
      (element.closest('.site-header') ? 'nav' : '') ||
      'unknown';
  }

  function dropState() {
    var root = document.querySelector('[data-aurelle-drop-state]');
    return root ? root.getAttribute('data-aurelle-drop-state') : 'auto';
  }

  function augmentSoldOutCards() {
    document.querySelectorAll('[data-product-grid]').forEach(function (card) {
      var link = card.querySelector('.grid-product__link');
      var title = card.querySelector('.grid-product__title');
      var meta = card.querySelector('.grid-product__meta');
      if (!link || !title || !meta) return;

      card.setAttribute('data-aurelle-product-title', title.textContent.trim());

      if (!meta.querySelector('.aurelle-card-badges') && !card.querySelector('.aurelle-product-badges') && link.classList.contains('grid-product__link--disabled')) {
        var badges = document.createElement('div');
        badges.className = 'aurelle-card-badges';
        var badge = document.createElement('span');
        badge.textContent = 'Waitlist only';
        badges.appendChild(badge);
        meta.appendChild(badges);
      }

      if (link.classList.contains('grid-product__link--disabled') && !card.querySelector('.aurelle-card-cta, .aurelle-card__cta')) {
        var cta = document.createElement('a');
        cta.className = 'aurelle-card-cta';
        cta.href = link.href.split('#')[0] + '#restock';
        cta.textContent = 'Join restock alert';
        cta.setAttribute('data-aurelle-waitlist-cta', '');
        cta.setAttribute('data-aurelle-source', 'collection');
        card.querySelector('.grid-product__content').appendChild(cta);
      }
    });
  }

  function bindTracking() {
    document.addEventListener('click', function (event) {
      if (window.__aurelleEventsLoaded) return;

      var waitlist = event.target.closest('[data-aurelle-waitlist-cta]');
      if (waitlist) {
        window.aurelleTrack('aurelle_waitlist_click', {
          source: sourceFor(waitlist),
          drop_state: dropState()
        });
      }

      var fitGuide = event.target.closest('a[href*="/pages/fit-guide"], [data-aurelle-fit-guide]');
      if (fitGuide) {
        window.aurelleTrack('aurelle_fit_guide_click', { source: sourceFor(fitGuide) });
      }

      var productCard = event.target.closest('[data-product-grid] .grid-product__link');
      if (productCard) {
        var card = productCard.closest('[data-product-grid]');
        window.aurelleTrack('aurelle_product_card_click', {
          source: 'collection',
          product_id: card ? card.getAttribute('data-id') : '',
          product_title: card ? card.getAttribute('data-aurelle-product-title') : ''
        });
      }

      var reviewLink = event.target.closest('a[href*="/pages/reviews"], .shopify-app-block');
      if (reviewLink) {
        window.aurelleTrack('aurelle_review_click', { source: sourceFor(reviewLink) });
      }

      var marketToggle = event.target.closest('[data-disclosure-toggle]');
      if (marketToggle && marketToggle.closest('.multi-selectors')) {
        window.aurelleTrack('aurelle_market_selector_open', { source: 'footer' });
      }
    }, true);

    document.addEventListener('submit', function (event) {
      if (window.__aurelleEventsLoaded) return;

      var form = event.target.closest('.aurelle-waitlist__form');
      if (form) {
        var wrapper = form.closest('.aurelle-waitlist');
        window.aurelleTrack('aurelle_waitlist_submit', {
          source: wrapper ? wrapper.getAttribute('data-aurelle-waitlist-source') : 'unknown',
          drop_state: dropState()
        });
      }
    }, true);
  }

  function observeFirstAccess() {
    var target = document.getElementById('first-access');
    if (!target || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (window.__aurelleEventsLoaded) {
            observer.disconnect();
            return;
          }
          window.aurelleTrack('aurelle_first_access_view', { source: 'first-access' });
          observer.disconnect();
        }
      });
    }, { threshold: 0.35 });
    observer.observe(target);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function initialsFor(name) {
    var words = String(name || 'A').trim().split(/\s+/);
    return words.slice(0, 2).map(function (word) {
      return word.charAt(0);
    }).join('').toUpperCase() || 'A';
  }

  function truncateReview(text) {
    var value = String(text || '').trim();
    if (value.length <= 168) return { text: value, truncated: false };
    return { text: value.slice(0, 165).replace(/\s+\S*$/, ''), truncated: true };
  }

  function renderStars(rating) {
    var value = Math.max(0, Math.min(5, Number(rating) || 0));
    var html = '';
    for (var index = 1; index <= 5; index += 1) {
      html += '<span class="aurelle-review-card__star' + (index > value ? ' aurelle-review-card__star--empty' : '') + '" aria-hidden="true">&#9733;</span>';
    }
    return '<div class="aurelle-review-card__stars" aria-label="' + value + ' out of 5 stars">' + html + '</div>';
  }

  function renderReviewCard(review) {
    var reviewText = truncateReview(review.reviewText);
    var avatar = review.avatar ?
      '<img src="' + escapeHtml(review.avatar) + '" alt="" loading="lazy">' :
      escapeHtml(initialsFor(review.name));
    var url = review.url ? escapeHtml(review.url) : '';

    return [
      '<article class="aurelle-review-card">',
        '<div class="aurelle-review-card__header">',
          '<span class="aurelle-review-card__avatar">' + avatar + '</span>',
          '<span class="aurelle-review-card__name">' + escapeHtml(review.name || 'Aurelle customer') + '</span>',
          '<span class="aurelle-review-card__source" aria-hidden="true">&#9733;</span>',
        '</div>',
        renderStars(review.ratingValue),
        review.reviewTitle ? '<div class="aurelle-review-card__title">' + escapeHtml(review.reviewTitle) + '</div>' : '',
        '<p class="aurelle-review-card__body">' + escapeHtml(reviewText.text) + (reviewText.truncated ? '<span class="aurelle-review-card__more">... more</span>' : '') + '</p>',
        '<div class="aurelle-review-card__footer">',
          url ? '<a href="' + url + '" target="_blank" rel="noopener noreferrer">Read more</a>' : '<span></span>',
          '<span>' + escapeHtml(review.date || '') + '</span>',
        '</div>',
      '</article>'
    ].join('');
  }

  function initReviewsWall() {
    document.querySelectorAll('[data-aurelle-reviews-wall]').forEach(function (section) {
      var widgetId = section.getAttribute('data-widget-id');
      var grid = section.querySelector('[data-aurelle-reviews-grid]');
      var more = section.querySelector('[data-aurelle-reviews-more]');
      var limit = parseInt(section.getAttribute('data-limit'), 10) || 12;
      var rendered = limit;

      if (!widgetId || !grid) return;
      section.style.setProperty('--aurelle-review-star', section.getAttribute('data-star-color') || '#173e42');

      function render(reviews) {
        grid.innerHTML = reviews.slice(0, rendered).map(renderReviewCard).join('');
        if (more) {
          more.hidden = rendered >= reviews.length;
          more.onclick = function () {
            rendered = Math.min(rendered + limit, reviews.length);
            render(reviews);
          };
        }
      }

      fetch('https://api.getwally.net/api/widget/' + encodeURIComponent(widgetId))
        .then(function (response) {
          if (!response.ok) throw new Error('Reviews unavailable');
          return response.json();
        })
        .then(function (data) {
          var reviews = (data.testimonials || []).filter(function (review) {
            return review && review.status === 'approved';
          }).sort(function (a, b) {
            var ratingDelta = (Number(b.ratingValue) || 0) - (Number(a.ratingValue) || 0);
            if (ratingDelta) return ratingDelta;
            return String(b.date || '').localeCompare(String(a.date || ''));
          });
          if (!reviews.length) throw new Error('No reviews');
          render(reviews);
        })
        .catch(function () {
          grid.innerHTML = '<div class="aurelle-reviews-wall__error">Reviews are temporarily unavailable.</div>';
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    augmentSoldOutCards();
    bindTracking();
    observeFirstAccess();
    initReviewsWall();
  });
})();
